module.exports = __webpack_public_path__ + "img/91.409619f.png";